import { IEslTemplateBuilding } from "./eslTemplatebuilding";
import IEslTemplateItem from "./eslTemplateElement";

export default interface IEslTemplate {
    id: string;
    name: string;
    width: number;
    height: number;
    elements: IEslTemplateItem[];
    buildings: IEslTemplateBuilding[];
}

export const DEFAULT_ESL_TEMPLATE: IEslTemplate = {
    id: "00000000-0000-0000-0000-000000000000",
    name: "",
    width: 480,
    height: 800,
    elements: [],
    buildings: [],
};
